module.exports = __webpack_public_path__ + "static/media/fondo-mytrust.cc14d81d.jpeg";